export default "__VITE_ASSET__lG7KiNt$__"